import { DefaultCarPageComponentProps } from "@/app/interface/components";
import DifferentialsSection from "./DifferentialsSection";

const DifferentialsComponent = ({
  car,
  model,
  version,
  setModel,
  setVersion,
  setColor,
}: DefaultCarPageComponentProps) => {
  return (
    <main className="flex flex-col bg-white">
      <div className="flex overflow-hidden relative flex-col items-center  w-full  max-md:px-5 max-md:max-w-full">
        <header className="flex bg-zinc-900 z-0 flex-wrap gap-10 justify-between items-start max-w-full text-3xl font-semibold leading-none rounded-t-3xl text-gray-900 whitespace-nowrap w-[1140px]">
          <h1 className="min-h-[58px] text-white min-w-[240px] w-full  flex justify-center  items-center  max-md:max-w-full">
            Diferenciais
          </h1>
        </header>
        <div className="w-full bg-zinc-900 flex items-center -mt-3">
          <DifferentialsSection
            car={car}
            model={model}
            version={version}
            setModel={setModel}
            setVersion={setVersion}
            setColor={setColor}
          />
        </div>
      </div>
    </main>
  );
};

export default DifferentialsComponent;
